import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { useTranslation } from 'react-i18next';
import React, { useRef, useState } from 'react';
import HeroSimple from '@/sections/HeroSimple';
import { SeoHeader } from '@/components/SeoHeader';
import { isAllowedRoute } from '@/lang/pagesConfig';
import Overlay from '@/sections/deprecatedInsurance/Overlay';
import Disclaimer from '@/sections/deprecatedInsurance/Disclaimer';
import { ExtendedWarrantyConditions } from '@/sections/deprecatedInsurance/ExtendedWarrantyConditions';
import { InsuranceConditions } from '@/sections/deprecatedInsurance/InsuranceConditions';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import MoreInfoSection from '@/sections/MoreInfo';
import IconCard from '@/assets/icons/heroIcons/Card-front.svg';
import IconThird from '@/assets/icons/heroIcons/Icon-third.svg';
import IconMaxi from '@/assets/icons/heroIcons/Maxi.svg';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import { LINKS } from '@/constants/links';
import { Header } from '@/sections/layout/Header';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
type SelectedSectionType = 'extendedWarranty' | 'insurance' | null;
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(72);
  const {
    menuPromoBanners
  } = t0;
  usePageView("deprecatedInsuranceToS");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["deprecatedInsuranceToS", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const extendedWarrantyRef = useRef(null);
  const insuranceRef = useRef(null);
  const [selectedSection, setSelectedSection] = useState(null);
  let t2;
  if ($[1] !== selectedSection) {
    t2 = id => ({
      isOpen: selectedSection === id,
      onOpen: () => setSelectedSection(id),
      onClose: () => setSelectedSection(null)
    });
    $[1] = selectedSection;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const generateToggleProps = t2;
  let t3;
  if ($[3] !== menuPromoBanners) {
    t3 = <Header enforceBackground={true} menuPromoBanners={menuPromoBanners} />;
    $[3] = menuPromoBanners;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("notAvailable.title");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <Overlay title={t4} />;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("seo.title");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("seo.description");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <SeoHeader title={t6} description={t7} nofollow={true} noindex={true} />;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t) {
    t9 = t("banner.title");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <HeroSimple title={t9} className="bg-blue-50" />;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== generateToggleProps) {
    t11 = <div ref={extendedWarrantyRef} className="scroll-mt-20 lg:scroll-mt-26"><ExtendedWarrantyConditions {...generateToggleProps("extendedWarranty")} /></div>;
    $[20] = generateToggleProps;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== generateToggleProps) {
    t12 = <div ref={insuranceRef} className="scroll-mt-20 lg:scroll-mt-26"><InsuranceConditions {...generateToggleProps("insurance")} /></div>;
    $[22] = generateToggleProps;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = <div className="bg-blue-50 px-4 pt-4 pb-20 lg:pt-10 lg:pb-40"><div className="relative z-10 mx-auto flex max-w-[75rem] flex-col gap-6">{t11}{t12}</div></div>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <SectionDelimiter color="bg-blue-100" background="bg-blue-50" />;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <IconDeferredPayment className="fillButtonIcon" />;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t) {
    t16 = t("core:products.deferredPayment");
    $[29] = t;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = LINKS();
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t16) {
    t18 = {
      analyticsParam: "termsAndConditionsMoreInfoDeferredPayment",
      icon: t15,
      testId: "termsAndConditionsMoreInfoDeferredPayment",
      title: t16,
      to: t17.deferredPayment
    };
    $[32] = t16;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <IconMaxi className="fillButtonIcon" />;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t) {
    t20 = t("core:products.revolving");
    $[35] = t;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = LINKS();
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t20) {
    t22 = {
      analyticsParam: "termsAndConditionsMoreInfoRevolvingApplication",
      icon: t19,
      testId: "termsAndConditionsMoreInfoRevolvingApplication",
      title: t20,
      to: t21.revolving
    };
    $[38] = t20;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <IconThird className="fillButtonIcon" />;
    $[40] = t23;
  } else {
    t23 = $[40];
  }
  let t24;
  if ($[41] !== t) {
    t24 = t("core:link.payInThree");
    $[41] = t;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = LINKS();
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== t24) {
    t26 = {
      analyticsParam: "termsAndConditionsMoreInfoPayInThree",
      icon: t23,
      testId: "termsAndConditionsMoreInfoPayInThree",
      title: t24,
      to: t25.payInThree
    };
    $[44] = t24;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <IconCard className="fillButtonIcon" />;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== t) {
    t28 = t("core:products.card");
    $[47] = t;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = LINKS();
    $[49] = t29;
  } else {
    t29 = $[49];
  }
  let t30;
  if ($[50] !== t28) {
    t30 = {
      analyticsParam: "termsAndConditionsMoreInfoCard",
      icon: t27,
      testId: "termsAndConditionsMoreInfoCard",
      title: t28,
      to: t29.card
    };
    $[50] = t28;
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  let t31;
  if ($[52] !== t18 || $[53] !== t22 || $[54] !== t26 || $[55] !== t30) {
    t31 = <MoreInfoSection buttons={[t18, t22, t26, t30]} />;
    $[52] = t18;
    $[53] = t22;
    $[54] = t26;
    $[55] = t30;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] !== t) {
    t32 = <Disclaimer t={t} />;
    $[57] = t;
    $[58] = t32;
  } else {
    t32 = $[58];
  }
  let t33;
  if ($[59] !== t31 || $[60] !== t32) {
    t33 = <div className="relative z-10">{t31}{t32}</div>;
    $[59] = t31;
    $[60] = t32;
    $[61] = t33;
  } else {
    t33 = $[61];
  }
  let t34;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    $[62] = t34;
  } else {
    t34 = $[62];
  }
  let t35;
  if ($[63] !== t33) {
    t35 = <div className="relative overflow-hidden bg-blue-100">{t33}{t34}</div>;
    $[63] = t33;
    $[64] = t35;
  } else {
    t35 = $[64];
  }
  let t36;
  if ($[65] !== t10 || $[66] !== t13 || $[67] !== t3 || $[68] !== t35 || $[69] !== t5 || $[70] !== t8) {
    t36 = <Layout header={t3}>{t5}{t8}{t10}{t13}{t14}{t35}</Layout>;
    $[65] = t10;
    $[66] = t13;
    $[67] = t3;
    $[68] = t35;
    $[69] = t5;
    $[70] = t8;
    $[71] = t36;
  } else {
    t36 = $[71];
  }
  return t36;
}
export const getStaticProps: GetStaticProps = async ctx => {
  const isAllowed = isAllowedRoute('pojisteni/pojistne-podminky');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'deprecatedInsuranceToS']))
    }
  };
};